import { Button } from '../ui/button';

export function GeneralError({ className = '', minimal = false }) {
    const goBack = () => window.history.back();
    const goHome = () => window.location.assign('/dashboard');

    return (
        <div className={`tailwind-scope ${className}`}>
            <div className="tw-h-svh tw-w-full">
                <div className="tw-m-auto tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-2">
                    {!minimal && (
                        <h1 className="tw-text-[7rem] tw-font-bold tw-leading-tight">500</h1>
                    )}
                    <span className="tw-font-medium">Oops! Something went wrong {`:)`}</span>
                    <p className="tw-text-center tw-text-muted-foreground">
                        We apologize for the inconvenience. <br /> Please try again later.
                    </p>
                    {!minimal && (
                        <div className="tw-mt-6 tw-flex tw-gap-4">
                            <Button variant="outline" onClick={goBack}>
                                Go Back
                            </Button>
                            <Button onClick={goHome}>Back to Home</Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
